import * as yup from 'yup';
import { notFutureDate } from 'utils/yupExtensions';
import { OnlineSpeakingMonitoringResult, OnlineSpeakingMonitoringType } from 'api';
import {
  VALID_ONLINE_SPEAKING_MONITORING_TYPES,
  VALID_ONLINE_SPEAKING_MONITORING_RESULTS,
} from './onlineSpeakingMonitoringOptions';

export const schema = yup.object({
  monitoringDate: notFutureDate().required('Monitoring date is required'),
  type: yup
    .mixed<OnlineSpeakingMonitoringType>()
    .oneOf(VALID_ONLINE_SPEAKING_MONITORING_TYPES)
    .required('Type is required'),
  result: yup
    .mixed<OnlineSpeakingMonitoringResult>()
    .oneOf(VALID_ONLINE_SPEAKING_MONITORING_RESULTS)
    .required('Result is required'),
  hasFollowUp: yup.boolean().default(false),
  comment: yup.string().max(500, 'Comment must be at most 500 characters').default(''),
});

export type OnlineSpeakingMonitoringFormData = yup.InferType<typeof schema>;
